import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import {
  ChakraProvider,
} from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { useAuth } from './contexts/AuthContext';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
// 🔥 helper redirect
const getRedirectByRole = (role) => {
  switch (role) {
    case "admin":
      return "/admin/default";
    case "teknisi":
      return "/admin/dashboard-teknisi";
    case "karyawan":
      return "/admin/dashboard_karyawan";
    default:
      return "/auth/sign-in";
  }
};

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

 const { token, role } = useAuth();
  const isLoggedIn = !!token;

  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route
          path="auth/*"
          element={isLoggedIn ? <Navigate to={getRedirectByRole(role)} replace /> : <AuthLayout />}
        />
        <Route
          path="admin/*"
          element={isLoggedIn ? <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} /> : <Navigate to="/auth/sign-in" replace />}
        />
        <Route path="/" element={isLoggedIn ? <Navigate to={getRedirectByRole(role)} replace /> : <Navigate to="/auth/sign-in" replace />} />
      </Routes>
    </ChakraProvider>
  );
}